import axios from 'axios';

import { parameters } from '../../constants/parameters';
import { Customer, CustomerEdit } from '../../entities/customer';
import OrdersListProps from '../../entities/ordersList';

export const list = async (token: string): Promise<Customer[]> => {
  const url = `${parameters.api.baseUrl}/customers/list`;

  const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });

  return res.data;
};

export const orders = async (token: string, customerId: number): Promise<OrdersListProps> => {
  const url = `${parameters.api.baseUrl}/orders/list?customerId=${customerId}`;

  const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });

  return res.data;
};

export const resolveMessage = async (token: string, customerId: number, status: number): Promise<Customer[]> => {
  const url = `${parameters.api.baseUrl}/customers/resolve/${customerId}/${status}`;

  const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });

  return res.data;
};

export const update = async (token: string, id: number, data: Partial<CustomerEdit>): Promise<Customer> => {
  const url = `${parameters.api.baseUrl}/customers/update/${id}`;

  try {
    const res = await axios.post(url, data, { headers: { Authorization: `Bearer ${token}` } });

    return res.data;
  } catch (e) {
    if (axios.isAxiosError(e)) {
      if (e.response?.data.error) {
        throw new Error(e.response?.data.error);
      }
    }

    throw e;
  }
};
